export const employeeYearInReviewTheme = {
  colors: {
    // Background
    bgPrimary: 'bg-main-gradient',
    bgSecondary: 'bg-sub-gradient',
    bgTertiary: 'bg-white',
    bgNeutralLight: 'bg-neutral',
    bgSlateAccent: 'bg-primary-500',
    bgSlateDark: 'bg-sub-gradient',
    bgSlateDeep: 'bg-primary-400',
    bgSlateDarker: 'bg-primary-550',
    bgSlateLight: 'bg-secondary-100',
    bgOutstanding: 'bg-gold-200',
    bgMemberCard: 'bg-primary-650',

    // Text
    textPrimary: 'text-white',
    textSecondary: 'text-gold',
    textTertiary: 'text-primary-300',
    textAccent: 'text-gold',
    decorative: 'text-primary-900',

    // Badge
    badgeBackground: {
      primary: 'bg-crimson',
      secondary: 'bg-primary-400',
      tertiary: 'bg-primary-700',
      quaternary: 'bg-primary-850',
    },
    badgeText: 'text-white',

    // Border & Stroke
    borderPrimary: 'border-primary-200',
    borderSecondary: 'border-secondary-100',
    borderNeutral: 'border-neutral-border',
    ringStroke: 'stroke-crimson',

    // Fill
    primaryFillIcon: 'fill-primary-200',
    secondaryFillIcon: 'fill-secondary-100',
  },
  typography: {
    '3xs': 'text-[24px] leading-none',
    '2xs': 'text-[30px] leading-none',
    xs: 'text-5xl leading-none',
    md: 'text-[64px] leading-none',
    lg: 'text-[90px] leading-none',
    xl: 'text-[200px] leading-none',
    base: 'text-10xl leading-none',
    badge: 'text-6xl font-medium tracking-widest uppercase',
    year: 'text-10xl',
    decorativeYear: 'text-[300px] font-bold leading-none',
  },
  fontSize: {
    lg: 90,
    xl: 120,
    base: 120,
    md: 64,
    sm: 48,
    xs: 40,
    '2xl': 250,
  },

  /**
   * Raw color values for components that need actual color values (e.g., SVG, canvas)
   */
  rawColors: {
    // DotGridBackground specific colors
    dotGridBackground:
      'linear-gradient(180deg, #E4317A 44.91%, #7E1B43 105.82%)',
    dotColor: '#86004E',
    lineColor: '#666b75',
    plusColor: '#ffffff',

    // RibbonAnimation specific colors
    ribbon: {
      body: '#F5C90A',
      sheenWhite: '#ffffff',
    },

    // ScrollingTileBackground specific colors
    scrollingTileBackground: {
      tileColor: '#0C408F',
      backgroundColor: '#152C91',
    },

    // WavyLinesBackground specific colors
    wavyLinesBackground: {
      lineColor: '#D5D5D5',
      backdropText: '#D5D5D5',
    },

    // ScrollingTextBackground specific colors
    scrollingTextBackground: {
      backgroundColor:
        'linear-gradient(180deg, #E4317A 44.91%, #7E1B43 105.82%)',
      textColor: '#3F0527',
    },

    // Training highlights palette
    trainingHighlights: {
      background: '#404653',
      circle: '#0C408F',
      card: '#E4317A',
      avatarRing: '#ababab',
      avatarFallback: '#E4317A',
      textPrimary: '#ffffff',
    },

    // Text fill animation color
    gold: '#F5C90A',
    goldSecondary: '#FFD003',
    textPrimary: '#404653',
    textSecondary: '#013660',
    textTertiary: '#ffffff',

    // Cursor color
    cursor: '#a5f3fc',

    // Quotation marks color
    quotationMark: '#ababab',

    // Sheen effect gradient
    sheenGradient:
      'linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.15) 50%, transparent 70%)',
  },
};
